import { Button } from '@mui/material';
import React from 'react';
import {
  DarkWebModal,
  SerializedDarkWebBreach,
} from '@/reports/darkWebScan/index';
import { Card, Text, Grid, Icons, Accordion, Box, styled } from '@/theme/index';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  whiteSpace: 'pre-wrap',

  '.MuiTypography-root': {
    fontWeight: 'bold',
    fontSize: theme.typography.body2.fontSize,
  },

  '&:hover, &.Mui-selected:hover': {
    border: `1px solid ${theme.palette.primary.main}`,
  },

  '&.Mui-expanded': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));

const criticalData = [
  'account balances',
  'bank account numbers',
  'credit cards',
  'credit status information',
  'dates of birth',
  'financial investments',
  'historical passwords',
  'home loan information',
  'net worths',
  'partial credit card data',
  'password hints',
  'passwords',
  'private messages',
  'security questions and answers',
  'social security numbers',
  'website activity',
];

export function DarkWebBreachedAccount({
  logoPath,
  name,
  date,
  compromisedData,
  description,
}: SerializedDarkWebBreach) {
  const [openState, setOpenState] = React.useState(false);

  const handleToggle = () => {
    setOpenState(!openState);
  };

  const isCritical = compromisedData?.some((data) =>
    criticalData.includes(data.toLowerCase())
  );

  return (
    <Card variant="outlined">
      <Grid
        container
        spacing={3}
        sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
      >
        <Grid container spacing={2} item xs={12} sm={9}>
          <Grid
            item
            xs={12}
            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
          >
            <img src={logoPath} alt="logo" width="35px" />{' '}
            <Text variant="h3" sx={{ display: 'inline-block', mb: 0 }}>
              {name}
            </Text>
          </Grid>
          {isCritical ? (
            <Grid item xs={12} mt="1rem">
              <Text
                variant="body2"
                color="error"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <Icons.Warning fontSize="small" sx={{ marginRight: '10px' }} />{' '}
                This is a critical breach: your sensitive information may have
                been compromised.
              </Text>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <Text variant="body2" sx={{ fontWeight: 'bold' }}>
              {date}
            </Text>
          </Grid>
          <Grid container spacing={1} item xs={12} alignItems="center">
            <Grid item xs={6} sm="auto" sx={{ alignSelf: 'baseline' }}>
              <Text variant="body2" sx={{ fontWeight: 'bold' }}>
                Compromised Data
              </Text>
            </Grid>
            <Grid item xs={6} sm={12}>
              <Box maxWidth={750}>{compromisedData?.join(', ')}</Box>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <StyledAccordion display="Background about this breach">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </StyledAccordion>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3} sx={{ position: 'relative' }}>
          <Button
            variant="contained"
            color="success"
            fullWidth
            onClick={handleToggle}
            sx={(theme) => ({
              [theme.breakpoints.up('sm')]: {
                position: 'absolute',
                width: '150px',
                right: 0,
              },
            })}
          >
            View next steps
          </Button>
        </Grid>
      </Grid>
      <DarkWebModal isOpen={openState} onCloseHandle={handleToggle} />
    </Card>
  );
}
